import React from 'react';
import ReactDOM from 'react-dom';
import DocumentMeta from 'react-document-meta';
import {
	createBrowserRouter,
	RouterProvider,
} from 'react-router-dom'

import './index.css';

import App from './App.js'
import Grayson from './Grayson.js';
import About from './About.js'
import Contact from './Contact.js'

const meta = {
	title: 'Jill Bryars',
	description: 'Jill Bryars makes ceramic figures.',
	canonical: 'http://jill-bryars.com',
	meta: {
		charset: 'utf-8',
		name: {
			keywords: 'jill bryars, jill, bryars, art, ceramics, clay, drawing, figures'
		}
	}
};

const router = createBrowserRouter([
	{
		path: "/",
		element: <App/>
	},
	{
		path: "/grayson-as-claire",
		element: <Grayson/>
	},
	{
		path: "/about",
		element: <About/>
	},
	// {
	// 	path: "/contact",
	// 	element: <Contact />,
	// },
]);

ReactDOM.render(
	<React.StrictMode>
		<DocumentMeta {...meta} />
		<RouterProvider router={router} />
	</React.StrictMode>,
	document.getElementById('root')
);
